// src/components/Footer.js
import React from "react";
import "./Footer.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <p>
          © 2024-{currentYear} College of Engineering Poonjar. All Rights Reserved.
        </p>

        <p>
          Designed & Developed by{" "}
          <span className="highlight">Naveen Shaji</span> and{" "}
          <span className="highlight">Bettina K. Peter</span>
        </p>

        <p>
          Maintained by{" "}
          <span className="highlight">
            Department of Computer Science and Engineering
          </span>
        </p>
      </div>
    </footer>
  );
};

export default Footer;